(function () {
  function init(root) {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    var storageKey = root.getAttribute('data-storage-key') || 'store_code';
    var cartAttributeName = root.getAttribute('data-cart-attribute') || 'store_code';
    var autoSync = (root.getAttribute('data-autosync') || '') === 'true';
    var statusTimeoutMs = parseInt(root.getAttribute('data-status-timeout') || '2500', 10);
    if (isNaN(statusTimeoutMs) || statusTimeoutMs < 0) statusTimeoutMs = 2500;

    var input = root.querySelector('#store-code-input');
    var button = root.querySelector('[data-store-code-save]');
    var status = root.querySelector('#store-code-status');

    var statusTimeoutId = null;

    readLocalStorage();

    if (button) {
      button.addEventListener('click', function () {
        saveNewStoreCode();
      });
    }

    if (input) {
      input.addEventListener('input', function () {
        if (button) button.classList.remove('is-success');
      });
    }

    if (autoSync) {
      syncToCartIfNeeded();
    }

    function saveNewStoreCode() {
      if (!input) return;

      var value = input.value || '';

      try {
        localStorage.setItem(storageKey, value);
      } catch (e) {
        return;
      }

      if (button) button.classList.add('is-success');

      if (status) {
        status.classList.add('is-visible');
        if (statusTimeoutId) clearTimeout(statusTimeoutId);
        statusTimeoutId = setTimeout(function () {
          status.classList.remove('is-visible');
        }, statusTimeoutMs);
      }

      if (autoSync) {
        syncCartAttribute(value, function () {
          try {
            localStorage.setItem(storageKey + '__last_applied_to_cart', value);
          } catch (e) {}
        });
      }
    }

    function readLocalStorage() {
      if (!input) return;

      try {
        var storedValue = localStorage.getItem(storageKey);
        if (storedValue) input.value = storedValue;
      } catch (e) {
        return;
      }
    }

    function syncToCartIfNeeded() {
      var storeCode = null;

      try {
        storeCode = localStorage.getItem(storageKey);
      } catch (e) {
        return;
      }

      if (!storeCode) return;

      var lastAppliedKey = storageKey + '__last_applied_to_cart';
      try {
        var lastApplied = localStorage.getItem(lastAppliedKey);
        if (lastApplied === storeCode) return;
      } catch (e) {}

      syncCartAttribute(storeCode, function () {
        try {
          localStorage.setItem(lastAppliedKey, storeCode);
        } catch (e) {}
      });
    }

    function syncCartAttribute(value, onDone) {
      var payload = { attributes: {} };
      payload.attributes[cartAttributeName] = value;

      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (response) { return response.json(); })
        .then(function () {
          if (typeof onDone === 'function') onDone();
        })
        .catch(function () {});
    }
  }

  function boot() {
    var roots = document.querySelectorAll('[data-store-code-section]');
    if (!roots || !roots.length) return;
    roots.forEach(function (root) { init(root); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
